<template>
    <files :reference-id="$route.params.slug" reference-type="proposal" />
</template>

<script>
    import Files from '../../../components/Files'

    export default {
        components: {
            Files
        }
    }
</script>
